import ReactGA from "react-ga4";

const measurementId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID || "G-G9D9Q5CXYL";
const analyticsEnabled =
  String(import.meta.env.VITE_GOOGLE_ANALYTICS_STAT || "")
    .trim()
    .toLowerCase() === "true";
let initialized = false;

export const isAnalyticsEnabled = () => analyticsEnabled && Boolean(measurementId);

/* Initialize Google Analytics */
export const initGA = () => {
  if (!isAnalyticsEnabled() || initialized) return;

  ReactGA.initialize(measurementId);
  console.log("Google Analytics initialized with ID:", measurementId);
  initialized = true;
};


/* Track Page Views */
export const logPageView = (path) => {
  if (!isAnalyticsEnabled()) return;

  const page = path || window.location.pathname;

  console.log("Logging page view:", page);

  ReactGA.send({
    hitType: "pageview",
    page: page
  });

};


/* Track Custom Events */
export const logEvent = (category = "", action = "", label = "") => {
  if (!isAnalyticsEnabled()) return;

  if (!category || !action) return;

  console.log("GA Event:", category, action, label);

  ReactGA.event({
    category: category,
    action: action,
    label: label
  });

};


/* Track Errors / Exceptions */
export const logException = (description = "", fatal = false) => {
  if (!isAnalyticsEnabled()) return;

  if (!description) return;

  // console.error("GA Exception:", description);

  ReactGA.event({
    category: "Error",
    action: description,
    label: fatal ? "Fatal Error" : "Non Fatal Error"
  });

};
